<template>
  <div class="goods">
    <van-swipe class="goods-swipe" :autoplay="3000">
      <van-swipe-item v-for="thumb in images.thumb" :key="thumb">
        <img :src="thumb" >
      </van-swipe-item>
    </van-swipe>
    <van-grid :column-num="2" gutter="0.3rem" icon-size="1rem" >
      <van-grid-item icon="/img/input.png" to="purchase" text="采购入库" />
      <van-grid-item icon="/img/output.png" to="consuming" text="领用出库" />
      <van-grid-item icon="/img/zengpin.png" to="recordcheck" text="出入库审核" />
      <van-grid-item icon="/img/pandian.png" to="inventory" text="库存盘点" />
      <van-grid-item icon="/img/log.png" to="record" text="出入库记录" />
      <van-grid-item icon="/img/shoufacun.png" to="stockrecord" text="收发存查询" />
      <van-grid-item icon="/img/tuihuo.png" to="salesreturn" text="退货管理" />
      <van-grid-item icon="/img/diaobo.png" to="allot" text="调拨管理" />
      <van-grid-item icon="/img/baosun.png" to="scrapped" text="报损出库" />
      <!-- <van-grid-item icon="/img/saleoutput.png" to="sale" text="销售出库" /> -->
    </van-grid>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import {Swipe,SwipeItem,Grid,GridItem,Icon} from 'vant';
  import Bottom from '../bottom/index.vue';
  export default {
    components: {
      Bottom,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Icon.name]: Icon,
    },
    data() {
      return {
        images: {
          thumb: [
            '/img/1.jpg',
            '/img/2.jpg',
            '/img/3.jpg',
            '/img/6.jpg'
          ]
        }
      };
    }
  };
</script>

<style lang="less">
.goods {
    &-swipe {
        height:5rem;
        img {
            width: 100%;
            
            display: block;
        }
    }
}

.van-grid{
    margin-top:0.3rem;
}
.van-grid-item__content{
    background:#09447d!important;
   
}
.van-grid-item__text{
     color:white!important;
     
}

</style>
